import React, { Component } from 'react';
import skills from '../static/storage/skills.json';
import '../styles/skills.css';

class Skills extends Component {
    constructor(props)
    {
        super(props);
        this.state={
            'myskills':['HTML','CSS','JS','PHP','REACT JS','FIREBASE','MIT APP']
        };
    }

    render() {
        return (
            <div className="condiv skills">
            <h1 className="subtopic">My Skills</h1>
            <h5>Programming Language : </h5>
            <ul className="skill">
            {skills["Programming Language"].map((value)=>{
                return <li key={value}>{value}</li>
            })}
            </ul>
            <h5>FrontEnd Framework : </h5>
            <ul className="skill">
            {skills["frontendframework"].map((value)=>{
                return <li key={value}>{value}</li>
            })}
            </ul>
            <h5>BackEnd Framework : </h5>
            <ul className="skill">
            {skills["backendframeworks"].map((value)=>{
                return <li key={value}>{value}</li>
            })}
            </ul>
            <h5>Database : </h5>
            <ul className="skill">
            {skills["database"].map((value)=>{
                return <li key={value}>{value}</li>
            })}
            </ul>
            <h5>Specializations : </h5>
            <ul className="skill">
            {skills["specialization"].map((value)=>{
                return <li key={value}>{value}</li>
            })}
            </ul>
            </div>
            )
        }
    }
    
    export default Skills;
    